import { render, staticRenderFns } from "./SystemAndPackageMenuSelector.vue?vue&type=template&id=347780fe"
import script from "./SystemAndPackageMenuSelector.vue?vue&type=script&lang=ts"
export * from "./SystemAndPackageMenuSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports